export default __webpack_public_path__ + "static/media/3h.3a006591.svg";